import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRequestService} from '../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { TranslationService } from '../../translation/translation.service';
import { HttpError } from '../../shared/httperror';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { GetDownloadUrlsRequest } from './getdownloadurlsrequest';
import { GetDownloadUrlsResponse } from './getdownloadurlsresponse';
import { MAT_DIALOG_DATA, MatDialog,MatDialogConfig } from '@angular/material/dialog';
import { DeletefilepopupComponent } from './deletefilepopup/deletefilepopup.component';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { UploadFileResponse } from '../../banners/uploadfileresponse';

@Component({
    selector: 'app-filemanager',
    templateUrl: './filemanagerpopup.component.html',
    styleUrls: ['./filemanagerpopup.component.scss']
})
export class FilemanagerComponent implements OnInit {

    downloadFileUrl = '';

    fileBaseUrl = '';

    getdownloadUrisUrl = '/file/getdownloadurls';

    downloadFileUriList?: Array<string>;

    uploadFileToASpecificFolderUrl = '/admin/upload-file-to-a-folder';

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;
    fileCover: File | null = null;

    uploadCoverFile = false;

    selectedAlign: 'start' | 'center' | 'end';

    //the directoryName can be overriden in any app.component.ts
    specificFolder = 'articles';

    uploadFileResponse: UploadFileResponse = {};

    isExtraSmall: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';


    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        private _toastMessageService: ToastmessageService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _matdialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public folderName: string,
        private _translateService:TranslationService,
        private _matDialog: MatDialog,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.downloadFileUrl = _downloadFileUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.selectedAlign='end';
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);

    }

    ngOnInit(): void {

        const getDownloadUrlsRequest: GetDownloadUrlsRequest = {
            folderName: 'articles'
        }

        this._apiRequestService
            .sendRequest<GetDownloadUrlsRequest, GetDownloadUrlsResponse>(this.fileBaseUrl, true, getDownloadUrlsRequest, true, this.getdownloadUrisUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response: GetDownloadUrlsResponse) => {
                this.downloadFileUriList = response.downloadUrls;

            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    removeFile() {

    }

    uploadFile() {
        this._apiRequestService
        .uploadFileToASpecificFolder(this.fileCover!,this.specificFolder,true, true, this.fileBaseUrl, this.uploadFileToASpecificFolderUrl)
        .pipe(
            catchError((error: HttpErrorResponse) => {
                return throwError(() => {
                    const httpError: HttpError = error.error as HttpError;
                    this._toastMessageService.displayToastMessage(
                        TOAST_STATE.error,
                        this._translateService.translate('admin.unsuccessfulSave! ' + httpError.errorMessage),
                        MAT_ICON.error
                    );
                    this.dismissError();
                });
            })
        )
        .subscribe((response) => {
            this.uploadFileResponse = response as UploadFileResponse;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.success,
                this.uploadFileResponse.fileName!,
                MAT_ICON.success
            );
            this.dismissError();
            this.openFileManagerPopup();

    });
}

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            this.uploadCoverFile = true;
        }
        else {
            this.uploadCoverFile = false;
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem ".jpg" vagy ".png" kiterjesztésű fájlt töltsön fel!', MAT_ICON.warning);
            this.dismissError();
        }

    }

    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.uploadCoverFile = false;
    }

    openDeleteFilePopup(downloadUri: string) {
        const popupDialog = this._matDialog.open(DeletefilepopupComponent, {
            data: downloadUri,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    openFileManagerPopup() {
        const popupDialog = this._matDialog.open(FilemanagerComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size: any) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

    showToastMessage(downloadUri:string) {
        this._toastMessageService.displayToastMessage(
            TOAST_STATE.success,
            "Kép vágólapra helyezve!",
            MAT_ICON.success
        );
        this.dismissError();
        this._matdialog.closeAll();
    }

}
